<here-map appId="PGdmLWDqMpjUIvS28qrk" appCode="tfrc343AbP8CCjd2PKNbJHp80sugVeXNMZxF5vi8kMk" [start]="start" [finish]="finish" width="100%" height="530px"></here-map>
<span class="hidden"> Route Planner è un servizio gratuito che ti permette di pianificare con comodità i tuoi viaggi utilizando un sistema di mappe e di routing adatte proprio a 
    viaggi in camper o in camion. Basta selezionare nella apposita casella iol mezzo usato ed il sistema, automaticamente valuterà il percorso migliore per il veicolo che hai scelto.
</span>

